import axios from 'axios'

// Usar VUE_APP_API_URL se definido, senão usar '/api' (proxy em dev ou relativo em prod)
const baseURL = process.env.VUE_APP_API_URL 
  ? `${process.env.VUE_APP_API_URL}/api`
  : '/api'

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    // Adicionar empresaId = 3 em rotas que precisam (produtos, categorias, clientes, vendas, integradores)
    const rotasComEmpresaId = ['/produtos', '/categorias', '/clientes', '/vendas', '/integradores']
    const precisaEmpresaId = rotasComEmpresaId.some(rota => config.url.includes(rota))
    
    if (precisaEmpresaId) {
      if (config.method === 'get') {
        // Para GET, adicionar nos params
        if (config.params) {
          config.params.empresaId = 3
        } else {
          config.params = { empresaId: 3 }
        }
      } else if ((config.method === 'post' || config.method === 'put') && config.data) {
        // Para POST/PUT, adicionar no body se não existir
        if (!config.data.empresaId) {
          config.data.empresaId = 3
        }
      }
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api

